import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Calendar as CalendarUI } from "@/components/ui/calendar";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SERVICES } from "@/lib/content";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SLOTS = ["10:00","11:00","12:00","15:00","16:00","17:00","18:00"];

export default function BookConsultation() {
  const [date, setDate] = useState(new Date(Date.now()+86400000));
  const [time, setTime] = useState("10:00");
  const [form, setForm] = useState({ name: "", email: "", phone: "", topic: "" });
  const [busy, setBusy] = useState(false);
  const set = (k,v)=>setForm(f=>({...f,[k]:v}));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const d = date.toISOString().slice(0,10);
      await axios.post(`${BACKEND}/api/consultations`, { ...form, preferred_date: d, preferred_time: time });
      toast.success("Booked! Pankaj will confirm shortly.");
      setForm({ name: "", email: "", phone: "", topic: "" });
    } catch { toast.error("Failed. Please retry or WhatsApp us."); }
    setBusy(false);
  };
  return (
    <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="chapter-num">Free Consultation</div>
          <h1 className="font-serif-display text-6xl md:text-7xl text-[var(--pta-navy)] mt-4 leading-[0.95]">30 minutes.<br /><em className="italic text-[var(--pta-gold)]">Zero cost.</em></h1>
          <p className="mt-6 text-lg text-[var(--pta-ink)]/75 max-w-md">Bring one problem you'd like a fresh perspective on. Books, GST, funding, process — anything.</p>
          <div className="mt-8 border hairline-navy p-4">
            <div className="overline">Select a date</div>
            <div className="mt-3"><CalendarUI mode="single" selected={date} onSelect={setDate} data-testid="book-calendar" disabled={(d)=>d < new Date(Date.now()-86400000)} /></div>
          </div>
        </div>
        <div className="lg:col-span-7">
          <form onSubmit={submit} className="border hairline-navy p-8 space-y-5">
            <div className="overline">Booking · {date?.toDateString()} · {time}</div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2">
              {SLOTS.map(s=><button type="button" key={s} data-testid={`slot-${s}`} onClick={()=>setTime(s)} className={`py-2 border font-mono-fine text-xs ${time===s?"bg-[var(--pta-navy)] text-[var(--pta-gold)] border-[var(--pta-navy)]":"hairline text-[var(--pta-ink)] hover:border-[var(--pta-navy)]"}`}>{s}</button>)}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-4">
              <div><Label className="overline">Name</Label><Input data-testid="book-name" required value={form.name} onChange={e=>set('name',e.target.value)} className="mt-2" /></div>
              <div><Label className="overline">Email</Label><Input data-testid="book-email" type="email" required value={form.email} onChange={e=>set('email',e.target.value)} className="mt-2" /></div>
              <div><Label className="overline">Phone</Label><Input data-testid="book-phone" required value={form.phone} onChange={e=>set('phone',e.target.value)} className="mt-2" /></div>
              <div><Label className="overline">Topic</Label>
                <Select value={form.topic} onValueChange={(v)=>set('topic',v)}><SelectTrigger data-testid="book-topic" className="mt-2"><SelectValue placeholder="What to discuss" /></SelectTrigger>
                  <SelectContent>{SERVICES.map(s=><SelectItem key={s.slug} value={s.title}>{s.title}</SelectItem>)}<SelectItem value="Other">Other</SelectItem></SelectContent>
                </Select>
              </div>
            </div>
            <button type="submit" data-testid="book-submit" disabled={busy} className="btn-pta w-full justify-center">{busy?"Booking…":"Confirm Booking"}</button>
          </form>
        </div>
      </div>
    </section>
  );
}
